// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React from 'react'
import { marketingUrlRoot } from 'constants/externalLinks'
import { CopyrightFooter } from 'components'
import { FaPlus, FaMinus } from 'components/FontAwesome'
import { useBooleanToggle } from 'hooks'
import Content from './Content'

import {
  CollapseInfo,
  ContactCol,
  ContactExpertLink,
  ContactRow,
  FooterDiv,
} from './styles'

const Footer = () => {
  const [isOpenAddress, toggleCollapsedAddress] = useBooleanToggle()
  const [isOpenContact, toggleCollapsedContact] = useBooleanToggle()
  const [isOpenPopup, toggleCollapsedPopup] = useBooleanToggle(false)

  return (
    <footer className={'margin-top-auto'}>
      {isOpenPopup
        ? <ContactRow>
          <ContactCol sm={3}>
            <FooterDiv>
              <h5>
                {'| ADDRESS'}
                {isOpenAddress
                  ? <FaMinus
                    className={'margin-left-1 cursor-pointer'}
                    onClick={toggleCollapsedAddress} />
                  : <FaPlus
                    className={'margin-left-1 cursor-pointer'}
                    onClick={toggleCollapsedAddress} />}
              </h5>
              <CollapseInfo isOpen={isOpenAddress}>
                <ul>
                  <li>{'Comsearch'}</li>
                  <li>{'21515 Ridgetop Circle, Ste. 300'}</li>
                  <li>{'Sterling, Virginia 20166'}</li>
                  <li>
                    <a
                      href={'https://www.google.com/maps/place/19700+Janelia+Farm+Blvd,+Ashburn,+VA+20147'}
                      rel={'noopener noreferrer'}
                      target={'_blank'}>
                      {'Directions'}
                    </a>
                  </li>
                </ul>
              </CollapseInfo>
            </FooterDiv>
          </ContactCol>
          <ContactCol
            sm={5}
            md={6}>
            <FooterDiv>
              <h5>
                {'| CONTACT'}
                {isOpenContact
                  ? <FaMinus
                    className={'margin-left-1 cursor-pointer'}
                    onClick={toggleCollapsedContact} />
                  : <FaPlus
                    className={'margin-left-1 cursor-pointer'}
                    onClick={toggleCollapsedContact} />}
              </h5>
              <CollapseInfo isOpen={isOpenContact}>
                <ul>
                  <li>
                    {'Telephone: '}
                    <a
                      href={'tel:1-703-726-5500'}
                      target={'_self'}>
                      {'+1 703 726 5500'}
                    </a>
                  </li>
                  <li>
                    {'Toll Free: '}
                    <a
                      href={'tel:1-800-318-1234'}
                      target={'_self'}>
                      {'+1 800 318 1234'}
                    </a>
                  </li>
                  <li>
                    {'Fax: '}
                    <a
                      href='tel:1-703-726-5595'
                      target='_self'>
                      {'+1 703 726 5595'}
                    </a>
                  </li>
                  <li>
                    {'Email: '}
                    <a
                      href='mailto:customersupport@comsearch.com'
                      target='_self'
                      rel='noopener noreferrer'>
                      {'customersupport@comsearch.com'}
                    </a>
                  </li>
                </ul>
              </CollapseInfo>
            </FooterDiv>
          </ContactCol>
          <ContactCol
            sm={'auto'}
            md={2}>
            <ContactExpertLink
              href={`${marketingUrlRoot}/contact-an-expert`}
              target={'_blank'}
              rel={'noopener noreferrer'}>
              {'CONTACT AN EXPERT'}
            </ContactExpertLink>
            <FooterDiv>
              <ul>
                <li>
                  <a
                    href={`${marketingUrlRoot}/company`}
                    rel={'noopener noreferrer'}
                    target={'_blank'}>
                    {'Company'}
                  </a>
                </li>
                <li>
                  <a
                    href={`${marketingUrlRoot}/news-resources`}
                    rel={'noopener noreferrer'}
                    target={'_blank'}>
                    {'News & Resources'}
                  </a>
                </li>
              </ul>
            </FooterDiv>
          </ContactCol>
        </ContactRow> : null}
      <Content toggleCollapsedPopup={toggleCollapsedPopup}/>
    </footer>
  )
}
export default Footer
